import React, { memo } from 'react';

import Popups from '../../components/Popup';
import { usePopupContext } from '../../contexts/PopupContext';

const MailingLogPopupContainer = ({ popup }) => {
  const { closePopup } = usePopupContext();
  const html = popup.getIn(['props', 'html']);
  const hasError = popup.getIn(['props', 'hasError']);
  const error = popup.getIn(['props', 'error']);

  const handleCloseClick = () => {
    closePopup();
  };

  return (
    <div>
      <Popups.MailingLogPopup error={error} hasError={hasError} html={html} onClose={handleCloseClick} />
    </div>
  );
};

export const MailingLogPopup = memo(MailingLogPopupContainer);
